import { ModelSagres } from "../../model-sagres";

export class ContratoResumido extends ModelSagres {
  IdContrato: number;
  NumeroAnoContrato: string;
  Tipo: string;
  ProcedimentoOrigem: string;
  Objeto: string;
  InicioVigencia: Date;
  FimVigencia: Date;
  DtAssinatura: Date;
  ValorContrato: number;
  Situacao?: string;

  /**
   * Usar o parâmetro opcional para receber um objeto do importador de XML
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.IdContrato = obj.IdContrato;
      this.NumeroAnoContrato = obj.NumeroAnoContrato;
      this.Tipo = obj.Tipo;
      this.ProcedimentoOrigem = obj.ProcedimentoOrigem;
      this.Objeto = obj.Objeto;
      if(obj.InicioVigencia)
        this.InicioVigencia = new Date(obj.InicioVigencia);
      if(obj.FimVigencia)
        this.FimVigencia = new Date(obj.FimVigencia);
      if(obj.DtAssinatura)
        this.DtAssinatura = new Date(obj.DtAssinatura);
      this.ValorContrato = obj.ValorContrato !== null ? Number(obj.ValorContrato): 0;
      this.Situacao = obj.Situacao;
    }
  }
}
